import {CarBodyType} from 'src/shared/types'

export const isCarBodyType = (value: unknown): value is CarBodyType =>
  value === CarBodyType.Van ||
  value === CarBodyType.LCV_M ||
  value === CarBodyType.LCV_L ||
  value === CarBodyType.LCV_XL ||
  value === CarBodyType.LCV_XXL
